
let ReactDOM = require("react-dom");
import * as React from "react";
import {FormBuilderOptions} from "FormBuilder/Core/FormBuilder.options";
import {FormBuilder, ProductData} from "FormBuilder/Core/FormBuilder";
import {CurrencyManager} from "FormBuilder/Utilities/Managers/CurrencyManager";
import {FormBuilderModel} from "FormBuilder/Core/FormBuilder.Model";




declare let ProductBuilderOptions:{
    Options:FormBuilderOptions,
    WCCurrency:any,
    Product:ProductData;
    PreviousData:any[];
    Variations:{
        Attributes:any;
    }
};

let interval=setInterval(MaybeLoadForm,100);
let loadedProducts=[];
window.addEventListener('DOMContentLoaded',()=>{
    clearInterval(interval);
});


function MaybeLoadForm(){
    let productList=document.querySelectorAll('.RNAddToCartContainer');

    for(let i=0;i<productList.length;i++)
    {
        let product=productList[i];
        let id=product.getAttribute('data-varid');
        if(loadedProducts.indexOf(id)>=0)
            continue;
        if(window['ProductBuilderOptions_'+id]!=null)
        {
            loadedProducts.push(id);

            let ProductBuilderOptions=window['ProductBuilderOptions_'+id] as any;
            if(!CurrencyManager.WasInitialized)
                CurrencyManager.Initialize(ProductBuilderOptions.WCCurrency);

            let options=new FormBuilderOptions().Merge(ProductBuilderOptions.Options);
            let model=new FormBuilderModel(options,null,ProductBuilderOptions.Product,ProductBuilderOptions.PreviousData,ProductBuilderOptions).Initialize();
            model.ExecuteFirstCalculation();
            ReactDOM.render(<FormBuilder  Model={model} PreviousData={ProductBuilderOptions.PreviousData}/>,product);
        }

    }





}

MaybeLoadForm();
